<template>
    <div id="add">
        <van-nav-bar class="nav-fixed"
                     :border="false"
                     :title="title"
                     left-arrow
                     :right-text="backFlag && !showList ? '完成' : ''"
                     @click-left="handleClickLeft"
                     @click-right="handleDone" />
        <div v-if="title != '新增药品'">
            <ul class="list"
                v-if="title == '用药频率'">
                <li :class="{ unitActive: unitActive === item.name }"
                    v-for="(item, index) in sourse"
                    :key="index"
                    @click="handleChoose(item.name, item.value, '用药频率')">
                    {{ item.name }}
                    <img v-if="unitActive === item.name"
                         src="../../../icons/active.png" />
                </li>
            </ul>
            <ul class="list"
                v-if="title == '用药方法'">
                <li :class="{ unitActive: unitActive === item.name }"
                    v-for="(item, index) in sourse"
                    :key="index"
                    @click="handleChoose(item.name, item.value, '用药方法')">
                    {{ item.name }}
                    <img v-if="unitActive === item.name"
                         src="../../../icons/active.png" />
                </li>
            </ul>
            <div class="textarea-wrap"
                 v-if="title == '用量'"
                 style="width:calc(100% - 40px);margin-left:20px;background:rgba(248,248,248,1);border-radius:8px; overflow:hidden">
                <van-field v-model="drugDosageInside"
                           rows="3"
                           autosize
                           type="textarea"
                           placeholder="请输入单次用量"
                           style="width:calc(100% - 40px);margin-left:20px;background:rgba(248,248,248,1);" />
            </div>

            <!-- <div
        class="textarea-wrap"
        v-if="title == '包装单位'"
        style="width:calc(100% - 40px);margin-left:20px;background:rgba(248,248,248,1);border-radius:8px; overflow:hidden"
      >
        <van-field
          v-model="unitName"
          autosize
          type="textarea"
          placeholder="请输入包装单位"
          style="width:calc(100% - 40px);margin-left:20px;background:rgba(248,248,248,1);"
        />
      </div>
      -->
            <ul class="list"
                v-if="title == '选择包装单位'">
                <li :class="{ unitActive: unitActive === item.name }"
                    v-for="(item, index) in sourse"
                    :key="index"
                    @click="handleChoose(item.name, item.value, '包装单位')">
                    {{ item.name }}
                    <img v-if="unitActive === item.name"
                         src="../../../icons/active.png" />
                </li>
            </ul>
            <ul class="list"
                v-if="title == '剂量单位'">
                <li :class="{ unitActive: unitActive === item.name }"
                    v-for="(item, index) in sourse"
                    :key="index"
                    @click="handleChoose(item.name, item.value, '剂量单位')">
                    {{ item.name }}
                    <img v-if="unitActive === item.name"
                         src="../../../icons/active.png" />
                </li>
            </ul>
            <van-cell-group class="pd16">
                <div class="textarea-wrap"
                     v-show="title == '通用信息'">
                    <van-field v-model="medicine.commonName"
                               type="textarea"
                               placeholder="请输入药品名称"
                               show-word-limit
                               maxlength="50"
                               class="gray"
                               auto-focus />
                </div>
            </van-cell-group>
            <div class="textarea-wrap"
                 v-show="title == '填写规格/型号'">
                <van-cell-group>
                    <van-field v-show="title == '填写规格/型号'"
                               v-model="medicine.attributeSpecification"
                               type="textarea"
                               placeholder="请输入规格/型号，示例:0.5g*10s*2板、0.125g*25袋"
                               show-word-limit
                               maxlength="50"
                               class="gray"
                               auto-focus />
                </van-cell-group>
            </div>
            <div class="textarea-wrap"
                 v-show="title == '填写条码'">
                <van-cell-group>
                    <van-field v-show="title == '填写条码'"
                               v-model="medicine.approvalNumber"
                               type="textarea"
                               placeholder="请输入条码，示例6920761821451"
                               show-word-limit
                               maxlength="50"
                               class="gray"
                               auto-focus />
                </van-cell-group>
            </div>
        </div>
        <div class="main"
             v-show="!backFlag">
            <div class="title">基本信息</div>
            <van-cell-group>
                <van-field label="通用信息"
                           required
                           v-model="medicine.commonName"
                           placeholder="请输入药品通用名"
                           :border="true"
                           disabled
                           right-icon="arrow"
                           @click="handleToInput('通用信息')" />
                <van-field label="规格/型号"
                           required
                           :value="medicine.attributeSpecification"
                           placeholder="请输入规格/型号"
                           :border="true"
                           disabled
                           right-icon="arrow"
                           @click="handleToInput('填写规格/型号')" />
                <van-field label="条码"
                           :value="medicine.approvalNumber"
                           placeholder="请输入条码"
                           :border="false"
                           disabled
                           right-icon="arrow"
                           @click="handleToInput('填写条码')" />
                <van-field label="包装单位"
                           required
                           :value="medicine.unitName"
                           placeholder="选择包装单位"
                           :border="true"
                           disabled
                           right-icon="arrow"
                           @click="handleToList('选择包装单位')" />
            </van-cell-group>
            <div class="header_title">
                <div class="title">用法用量</div>
                <div class="title_right">{{ buildUsageText }}</div>
            </div>
            <van-cell-group>
                
                <van-field required
                           label="用药方法"
                           :value="medicine.directions"
                           placeholder="请选择"
                           :border="true"
                            @click="handleToList('用药方法')" 
                            disabled
                           right-icon="arrow"
                          />

              <van-field required
                         type="digit"
                         v-if="medicine.singleUnit !== '适量'"
                         label="单次用量"
                         maxlength="3"
                         @input="singleDoseInput"
                         v-model="medicine.singleDose"
                         placeholder="请输入用量数"
                         :border="true" />

                <van-field
                    v-else
                    label="单次用量"
                    placeholder="“每次适量用药”该栏无需填写"
                    :border="true"
                    disabled/>
                <!-- right-icon="arrow" -->
                <!-- disabled -->
                <!-- @click="handleToList('用量')" -->
                <van-field required
                           label="剂量单位"
                           :value="medicine.singleUnit"
                           placeholder="请选择"
                           :border="true"
                           disabled
                           right-icon="arrow"
                           @click="handleToList('剂量单位')" />
                <van-field required
                           label="用药频率"
                           :value="medicine.useFrequency"
                           placeholder="请选择"
                           :border="true"
                           disabled
                           right-icon="arrow"
                           @click="handleToList('用药频率')" />
            </van-cell-group>
        </div>
        <van-button @click="handleAdd"
                    v-if="!backFlag"
                    type="info"
                    :disabled="!status"
                    round
                    size="large">确定</van-button>
    </div>
</template>

<script>
import {
    unitList,
    rateList,
    getMethod,
    getDose,
    addMedicine,
    postPackUnitList
} from '../../../api/index'
import { Dialog } from 'vant'
import { getCookie } from '@/utils/auth'

export default {
    data () {
        return {
            title: '新增药品',
            backFlag: false,
            medicine: {
                approvalNumber: '', // 条码/国药准字
                commonName: '', // 通用名称
                attributeSpecification: '', // 规格型号
                unitName: '', // 包装单位
                useFrequency: '', // 频率
                singleDose: '', // 单次计量
                singleUnit: '', // 单位
                directions: '' // 用药方法
            },
            unitData: [], //单位
            methodData: [], //方法
            dosageData: [], // 用量
            usedrugData: [], //频率
            sourse: [], // 列表数据
            packUnitList: [], //包装单位
            showList: false, // 是否展示列表
            drugDosageInside: '',
            unitName: '',
            unitActive: '' //选中的
        }
    },
    computed: {
        status () {
            if (
                this.medicine.commonName &&
                this.medicine.attributeSpecification &&
                this.medicine.useFrequency &&
                this.medicine.singleDose &&
                this.medicine.singleUnit &&
                this.medicine.directions &&
                this.medicine.unitName
            ) {
                return true
            } else {
                return false
            }
        },
        backStatus () {
            if (
                this.medicine.approvalNumber ||
                this.medicine.commonName ||
                this.medicine.attributeSpecification ||
                this.medicine.useFrequency ||
                this.medicine.singleDose ||
                this.medicine.singleUnit ||
                this.medicine.directions
            ) {
                return true
            } else {
                return false
            }
        },
        buildUsageText () {
            let fn = (value) => {
                if (value != null && value != undefined && value.length > 0) {
                    return value + '、'
                } else {
                    return ''
                }
            }
            let liang = this.medicine.singleDose.length > 0 ? `1次${this.medicine.singleDose}` : (this.medicine.singleDose || '');
            if(this.medicine.singleUnit ==='适量'){
              liang = '一次';
            }
            return `${fn(this.medicine.directions)}${liang}${fn(this.medicine.singleUnit)}${this.medicine.useFrequency || ''}`
        },
    },
    created () {
        this.unitFun()
        this.postPackUnit()
        this.rateListFun()
        this.methodFun()
        this.doseFun()
    },
    methods: {
         singleDoseInput(val){
             if (val) {
                let value = parseInt(val);
                if (value <= 0 || isNaN(value)) {
                   this.medicine.singleDose = ''
                   this.$toast({
                        message: '输入1-999的正整数',
                        duration: 1500
                    })
                }
            }
         },
        /**
         * @description:点击确认
         * @return: void
         */
        handleAdd () {
            const organSign = getCookie('native_organSign');
            const addKeys = {
                type: null,
                prescriptionYn: null,
                manufacturer: null,
                unitId: null,
                producingArea: null,
                systemType: null,
                remindContent: null,
                instructionsDto: {
                    usageAndDosage: null,
                    taboo: null
                }
            }
            const params = {
                organSign,
                commonName: this.medicine.commonName,
                attributeSpecification: this.medicine.attributeSpecification,
                useFrequency: this.medicine.useFrequency,
                singleDose: this.medicine.singleDose,
                singleUnit: this.medicine.singleUnit,
                directions: this.medicine.directions,
                approvalNumber: this.medicine.approvalNumber,
                unitName: this.medicine.unitName,
            }
            this.medicine.singleDoseValue = this.medicine.singleDose
            this.medicine = Object.assign(this.medicine, addKeys)
            this.submitMedicine(params)
            window.webSdk.track('ds_submit_new_medicines', {
                organSign,
                productName: this.medicine.commonName,
                spec: this.medicine.attributeSpecification,
                barCode: this.medicine.approvalNumber
            })
        },
        /**
         * @description:调用新增药品api
         * @param: {Object} medicine 药品信息
         * @return: void
         */
        async submitMedicine (params) {
            try {
                const res = await addMedicine(params)
                if (res.data.code === 0) {
                    this.$toast({
                        message: '新增成功',
                        duration: 1500
                    })
                    this.medicine.pref = res.data.result
                    this.medicine.num = 1
                    this.$emit('addmedicine', this.medicine)
                }
            } catch (err) {
                this.$toast({
                    message: err.msg || err
                })
            }
        },
        /**
         * @description:点击列表项选择
         * @param: { String } val 选中值
         * @return: void
         */
        handleChoose (name, val, type) {
            if (type === '用药频率') {
                this.medicine.useFrequency = name
                this.medicine.useFrequencyValue = val
            } else if (type === '用药方法') {
                this.medicine.directions = name
            } else if (type === '剂量单位') {
                this.medicine.singleUnit = name
                this.medicine.singleUnitValue = val
                 if(val === '适量'){
                   this.medicine.singleDose = "1"
                   this.medicine.singleDoseValue = "1"
                 }
            } else if (type === '用量') {
                this.medicine.singleDose = name
                this.medicine.singleDoseValue = val
            } else if (type === '包装单位') {
                this.medicine.unitName = name
                // this.medicine.singleDoseValue = val //todo
            }
            this.unitActive = val
            this.backFlag = this.showList = false
            this.title = '新增药品'
        },
        /**
         * @description: 获取药品使用单位
         * @param {void}
         * @return: void
         */
        async unitFun () {
            const res = await unitList()
            if (res) {
                this.unitData = res.data.data
            }
        },
        //获取包装单位
        async postPackUnit () {
            const res = await postPackUnitList()
            if (res) {
                this.packUnitList = res.data.data
            }
        },
        /**
         * @description: 获取药品用药方法
         * @param {void}
         * @return: void
         */
        // 获取用药方法
        async methodFun () {
            getMethod().then(res => {
                this.methodData = res.data.data
            })
        },
        /**
         * @description: 获取药品用量
         * @param {void}
         * @return: void
         */
        async doseFun () {
            getDose().then(res => {
                this.dosageData = res.data.data
            })
        },
        /**
         * @description: 获取药品使用频率
         * @param {void}
         * @return: void
         */
        async rateListFun () {
            const res = await rateList()
            if (res) {
                this.usedrugData = res.data.data
            }
        },
        /**
         * @description:点击右上角完成
         * @return: void
         */
        handleDone () {

            if (this.title === '包装单位') {
                if (this.unitName.length > 2) {
                    this.$toast({
                        duration: 2000,
                        message: '限制2字符以内'
                    })
                    return false
                }
                this.medicine.unitName = this.unitName
            }
            if (this.title === '用量') {
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
                const result = reg.test(this.drugDosageInside)
                if (result) {
                    this.$toast({
                        duration: 2000,
                        message: '不可输入汉字'
                    })
                    return false
                }
                if (this.drugDosageInside.length > 10) {
                    this.$toast({
                        duration: 2000,
                        message: '限制10字符以内'
                    })
                    return false
                }
                this.medicine.singleDose = this.drugDosageInside
                this.medicine.singleDoseValue = this.drugDosageInside
            }
            if (this.title === '填写规格/型号') {
                //   不允许 纯数字 纯中文 纯字母 纯符号， 不为空
                // const regex = /^(?=.*\d)(?=.*[a-zA-Z\u4e00-\u9fa5])(?=.*[!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?])\S+$/;
                const regex = new RegExp('^(?=.*[a-zA-Z])(?=.*[0-9])|(?=.*[a-zA-Z])(?=.*[\u4e00-\u9fa5])|(?=.*[0-9])(?=.*[\u4e00-\u9fa5])[a-zA-Z0-9\u4e00-\u9fa5]+$')
                if (!regex.test(this.medicine.attributeSpecification)) {
                    return this.$toast({
                        duration: 2000,
                        message: '不允许输入纯数字、纯中文、纯字母、纯符号，且不为空'
                    })
                }
            }
            this.backFlag = false
            this.title = '新增药品'
        },
        /**
         * @description:去选择
         * @return: void
         */
        handleToList (title) {
            console.log(title, '--------------------------------');
            this.title = title
            if (title === '用药频率') {
                this.sourse = this.usedrugData
                this.unitActive = this.medicine.useFrequency
            } else if (title === '用药方法') {
                this.sourse = this.methodData
                this.unitActive = this.medicine.directions
            } else if (title === '选择包装单位') {//todo
                // this.sourse = this.unitData
                // this.unitActive = this.medicine.singleUnit
                this.sourse = this.packUnitList
                this.unitActive = this.medicine.unitName
            } else if (title === '剂量单位') {
                this.sourse = this.unitData
                this.unitActive = this.medicine.unitName
            } else if (title === '用量') {
                this.sourse = this.dosageData
                this.unitActive = this.medicine.singleDose
                this.showList = false
                this.backFlag = true
                return false
            }
            this.showList = this.backFlag = true
        },
        /**
         * @description:去输入
         * @return: void
         */
        handleToInput (title) {
            this.title = title
            this.backFlag = true
        },
        /**
         * @description:点击返回
         * @return: void
         */
        handleClickLeft () {
            if (this.backFlag) {
                if (this.backStatus) {
                    // on confirm
                    this.backFlag = this.showList = false
                    if (this.title === '通用信息') {
                        this.medicine.commonName = ''
                    } else if (this.title === '填写规格/型号') {
                        this.medicine.attributeSpecification = ''
                    } else if (this.title === '填写条码') {
                        this.medicine.approvalNumber = ''
                    } else if (this.title === '用药频率') {
                        this.medicine.useFrequency = ''
                        this.medicine.useFrequencyValue = ''
                    } else if (this.title === '用药方法') {
                        this.medicine.directions = ''
                    } else if (this.title === '剂量单位') {
                        this.medicine.singleUnit = ''
                        this.medicine.singleUnitValue = ''
                    } else if (this.title === '用量') {
                        this.medicine.singleDose = ''
                        this.medicine.singleDoseValue = ''
                    } else if (this.title === '包装单位') {
                        this.medicine.unitName = ''
                    }
                    this.title = '新增药品'
                } else {
                    this.title = '新增药品'
                    this.backFlag = this.showList = false
                }
            } else {
                if (this.backStatus) {
                    Dialog.confirm({
                        message: '退出后信息将无法保存， 确定退出吗？'
                    })
                        .then(() => {
                            this.$emit('closeadd')
                        })
                        .catch(() => {
                            // on cancel
                            Dialog.close()
                        })
                } else {
                    this.$emit('closeadd')
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.van-nav-bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
}
.van-hairline--top-bottom::after {
    border-width: 0;
}

#add {
    width: 100%;
    height: calc(100vh - 50px);
    overflow-x: hidden;
    overflow-y: scroll;
    padding-top: 50px;
    position: fixed;
    z-index: 990;
    background: white;
    /deep/ .van-field__control {
        min-height: 0 !important;
    }
    .header_title {
        width: 100%;
        min-height: 46px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: rgba(245, 247, 248, 1);
    }
    .title {
        font-size: 19px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(34, 34, 34, 1);
        line-height: 46px;
        text-indent: 25px;
    }
    .title_right {
        flex: 1;
        text-align: end;
        word-break: break-all;
        padding-left: 15px;
        font-size: 14px;
        color: #adadad;
        padding-right: 20px;
    }
    .van-cell-group {
        padding-left: 16px;
    }
    .van-cell {
        height: 60px;
        align-items: center;
    }

    .box {
        height: 30px;
        display: flex;
        position: relative;
        top: -10px;
        left: 15px;
        span {
            padding: 0 13px;
            min-width: 50px;
            height: 30px;
            background: rgba(245, 245, 245, 1);
            border-radius: 15px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 30px;
            margin-right: 15px;
            display: inline-block;
            text-align: center;
        }
    }
    ul.list {
        li {
            text-indent: 25px;
            font-size: 17px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(34, 34, 34, 1);
            height: 60px;
            line-height: 60px;
            position: relative;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #ebedf0;
            img {
                width: 26px;
                height: 26px;
                position: absolute;
                right: 25px;
            }
        }
    }
    .unitActive {
        background: rgba(243, 250, 255, 1) !important;
    }
    .van-button {
        width: calc(100% - 50px);
        margin-left: 25px;
        margin-top: 50px;
    }
    .pd16 {
        padding: 0 16px;
    }
    .gray {
        background: rgba(248, 248, 248, 1);
        // padding-bottom: 25px;
        // margin-top: 14px;
        // & /deep/ textarea {
        //   padding: 14px 0 !important;
        // }
    }
    .textarea-wrap {
        background: rgba(248, 248, 248, 1);
        // padding: 14px 0;
        .van-cell {
            height: auto;
        }
    }
    /deep/ .van-field__control:disabled {
        -webkit-text-fill-color: unset !important;
    }
    .van-button--info {
        background-color: #01b956 !important;
        border-color: #01b956 !important;
    }
}
</style>
